import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { FileManager } from 'components/FileManager'
import useStyles from './FormArquivos.styles'

export const FormArquivos = (props) => {
  const { form } = props
  const classes = useStyles()

  // Sincronização inteligente com verificação de igualdade superficial para quebrar loop infinito de re-renderização
  const setArquivos = useCallback((arquivos) => {
    form.setFormState((prev) => {
      const currentArquivos = prev.values.arquivos || []
      const isIdentical =
        arquivos.length === currentArquivos.length &&
        arquivos.every((val, idx) => val === currentArquivos[idx])

      if (isIdentical) {
        return prev
      }
      return {
        ...prev,
        values: { ...prev.values, arquivos },
      }
    })
  }, [])

  return (
    <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
      <Grid className={classes.item} item md={12} sm={12} xs={12}>
        <FileManager
          rotaUpload="/arquivo/reconhecedorcadaver"
          rotaLoadImagem="/arquivo/reconhecedorcadaver"
          setArquivosPai={setArquivos}
          arquivosIniciais={[]}
          tipos={['image', 'pdf']}
        />
      </Grid>
    </Grid>
  )
}

FormArquivos.propTypes = {
  form: PropTypes.object.isRequired,
}
